// Clear console each hot module replacement time
if (module.hot) {
  module.hot.accept() // already had this init code

  module.hot.addStatusHandler(status => {
    if (status === 'prepare') console.clear()
  })
}



// WEBPACK FOOTER //
// ./src/plugins/hrm.js